import axios from 'axios';
import headers from "../Header";

let url = '/sdpi/wilayah'
class MasterWilayahService {
    getProvinsi() {
        return axios.get(url + '/provinsi', {
            headers: headers(),
        })
    }

    getKabupatenKotaByProvinsi(id) {
        return axios.get(url + '/kabupaten-kota?kode_prov=' + id, {
            headers: headers(),
        })
    }

    getKecamatanByKabupatenKota(id) {
        return axios.get(url + '/kecamatan?kode_kab=' + id, {
            headers: headers(),
        })
    }

    getDesaKelurahanByKecamatan(id) {
        return axios.get(url + '/desa-kelurahan?kode_kec=' + id, {
            headers: headers(),
        })
    }

    getSlsByDesa(id) {
        return axios.get(url + '/satuan-lingkungan-setempat?kode_desa=' + id, {
            headers: headers(),
        })
    }

}

export default new MasterWilayahService();